import axios from 'axios';
import config from './../configs/config';
import store from '../store'

export async function HTTP(method, uri, data, headers = null, params = null, showLodader, responseType, baseUrl = config.API_URL) {
    if (showLodader) {
        store.state.isLoading = true;
    }

    let url = (baseUrl + uri);

    let query = {
        method: method,
        url: url
    };
    let accessToken = localStorage.getItem("accessToken");   
    const token = "Bearer " + accessToken;
    if (headers !== null) {
        if (!headers.Authorization && !headers.authorization) {
            headers.Authorization = token;
        }
        query.headers = headers;
    }else{
        query.headers = {
            Authorization: token
        };
    }

    if (params !== null) {
        query.params = params;
    }

    if (method === 'post' || method === 'put' || method === 'delete' || method === 'patch' || method === 'options') {
        query.data = data;
    }
    
    if(responseType)
    {
        query.responseType = responseType;
    }

    if(process.env.VUE_APP_APPLICATION == "employee" || process.env.VUE_APP_APPLICATION == "remington_seeds"){
        query.withCredentials = true;
        // // console.log("Query after header & params: ", query);
    }


    const response = await axios(query);

    store.state.isLoading = false;
    // // console.log("response from axios received: ");

    return response;

}
